// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3ECR6","consentsList":"PatientConsents_consentsList__2MRyy","consentsListEmpty":"PatientConsents_consentsListEmpty__j-RXC"};